/**
 * Messages module translations - Statuses section
 */

const statuses = {
  approved: "Approved",
  notAccepted: "Not Accepted",
  inReview: "In Review",
};

export default statuses;
